<template>
  <div>
    <loader :loading="loading"></loader>
    <div v-if="showBreadcrumb" class="row">
      <div class="col">
        <breadcrumb :transparent="true">
          <breadcrumb-item v-if="showSurveysBreadcrumb">
            <router-link to="/admin/surveys">Surveys</router-link>
          </breadcrumb-item>
          <breadcrumb-item active>
            {{ survey.surveyName }} Instances
          </breadcrumb-item>
        </breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>{{ survey.surveyName }}</h3>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col">
        <div v-if="!loading" class="row justify-content-md-center">
          <div class="col-md-8">
            <card>
              <div slot="header"><h4 class="card-title">Survey Instances</h4></div>
              <div class="row">
                <div class="col-sm-12">
                  <el-table :data="survey.orgSurveys">
                    <el-table-column type="expand" v-if="!isUser">
                      <template slot-scope="props">
                        <div>Live Survey URL: <a :href="props.row.surveyUrl" target="_blank"><span class="active-link">{{ props.row.surveyUrl }}</span></a></div>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="115" label="URL ID">
                      <template scope="scope"><router-link class="active-link" :to="gotoRouteLink(scope.row)">{{ scope.row.surveyUrlId }}</router-link></template>
                    </el-table-column>
                    <el-table-column min-width="150" align="center" label="Start Date">
                      <template scope="scope">{{ displayDate(scope.row.startDate) }}</template>
                    </el-table-column>
                    <el-table-column min-width="150" align="center" label="End Date">
                      <template scope="scope">{{ displayDate(scope.row.endDate) }}</template>
                    </el-table-column>
                    <el-table-column min-width="115" label="Access Type">
                      <template scope="scope">{{ scope.row.accessTypeName }}</template>
                    </el-table-column>
                    <el-table-column min-width="100" label="Actions" align="right" v-if="!isUser">
                      <template scope="scope">
                        <router-link v-if="isInternalAdmin" class="active-link" :to="{ name: 'InstanceLinks', params: { surveyUrlId: scope.row.surveyUrlId } }">
                          <el-tooltip
                            content="Manage Links"
                            effect="light"
                            :open-delay="300"
                            placement="top">
                            <base-button class="btn-link p-0" type="primary" size="sm" aria-label="Manage Links" icon>
                              <i class="tim-icons icon-link-72"></i>
                            </base-button>
                          </el-tooltip>
                        </router-link>
                        <router-link v-if="isInternalAdmin" class="active-link" :to="{ name: 'InstanceSurveyUsers', params: { surveyUrlId: scope.row.surveyUrlId } }">
                          <el-tooltip
                            content="Manage Users"
                            effect="light"
                            :open-delay="300"
                            placement="top">
                            <base-button class="btn-link p-0" type="primary" size="sm" aria-label="Manage Users" icon>
                              <i class="tim-icons icon-single-02"></i>
                            </base-button>
                          </el-tooltip>
                        </router-link>
                        <a :href="scope.row.reviewUrl" target="_blank">
                          <el-tooltip
                            content="Review Survey"
                            effect="light"
                            :open-delay="300"
                            placement="top">
                            <base-button class="btn-link p-0" type="primary" size="sm" aria-label="Review Survey" icon>
                              <i class="tim-icons icon-laptop"></i>
                            </base-button>
                          </el-tooltip>
                        </a>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column min-width="100" align="center" label="Requires Approval">
                      <template scope="scope">{{ scope.row.requiresApproval ? trueDisplayValue : falseDisplayValue }}</template>
                    </el-table-column>
                    <el-table-column min-width="100" prop="activeCount" align="center" label="Instances">
                      <template scope="scope">{{ scope.row.orgSurveys.length }}</template>
                    </el-table-column> -->
                    <!-- <el-table-column
                      min-width="100"
                      header-align="right"
                      align="right"
                      label="Actions">
                      <div
                        slot-scope="{ row, $index }"
                        class="text-right table-actions">
                        <el-tooltip
                          content="Edit"
                          effect="light"
                          :open-delay="300"
                          placement="top">
                          <base-button
                            @click.native="handleEdit(row, $index)"
                            type="warning"
                            icon
                            size="sm"
                            class="btn-link">
                            <span class="sr-only">Edit Survey</span>
                            <i class="tim-icons icon-pencil"></i>
                          </base-button>
                        </el-tooltip>
                      </div>
                    </el-table-column> -->
                  </el-table>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb.vue';
  import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem.vue';
  import { mapGetters } from 'vuex';
  import { Table, TableColumn } from 'element-ui';
  import { formatDateDefault } from 'src/modules/utils';
  import { getUserSurveys } from 'src/modules/adminActions';
  import { isNullOrEmpty, copyObject } from '../../modules/utils';

  export default {
    name: 'Welcome',
    components: {
      Loader,
      Breadcrumb,
      BreadcrumbItem,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
        trueDisplayValue: 'Yes',
        falseDisplayValue: 'No',
        survey: {
          orgSurveys: []
        },
        surveyInfo: "",
        userSurveys: null,
      };
    },
    computed: {
      loading: function() {
        return this.survey.orgSurveys.length === 0;
      },
      isInternalAdmin() {
        return this.adminUserIsInternalAdmin;
      },
      isUser() {
        return this.adminUserIsUser;
      },
      showBreadcrumb() {
        if (isNullOrEmpty(this.$route.params.routeFrom) || this.$route.params.routeFrom === "surveys") {
          return true;
        }

        // If routed from the Login page, don't display the breadcrumb
        return false;
      },
      showSurveysBreadcrumb() {
        if (isNullOrEmpty(this.userAssignments) || (this.userAssignments.numberOfSurveys > 1 && this.userAssignments.numberOfSurveyInstances > 1)) {
          return true;
        }

        return false;
      },
      ...mapGetters({
        getSurveyById: 'getSurveyById',
        adminUserIsInternalAdmin: 'adminUserIsInternalAdmin',
        adminUserIsUser: 'adminUserIsUser',
        userAssignments: 'userAssignments',
      })
    },
    methods: {
      displayDate: formatDateDefault('None'),
      handleEdit(row, index) {
        console.log(row);
      },
      getAssignedSurveys() {
        if (!this.isInternalAdmin) {
          if (this.userAssignments) {
            this.userSurveys = this.userAssignments.userSurveys;
          }
          else {
            getUserSurveys()
              .then(response => {
                this.userSurveys = response.data;
                this.filterSurvey();
              });

            return;
          }
        }

        this.filterSurvey();
      },
      filterSurvey() {
        let survey = {
          orgSurveys: []
        };

        let stateSurvey = this.getSurveyById(this.$route.params.surveyId);
        if (stateSurvey) {
          survey = copyObject(stateSurvey);
          if (this.userSurveys) {
            survey.orgSurveys = survey.orgSurveys.filter(x => 
              this.userSurveys.findIndex(y => y.hspSurveyId === x.hspSurveyId || y.orgSurveyId === x.orgSurveyId) > -1
            );
          }

          survey.orgSurveys.forEach(orgSurvey => {
            orgSurvey.reviewUrl = `${process.env.VUE_APP_URL}/surveys/access/${orgSurvey.hspSurveyId}/${orgSurvey.surveyUrlId}/review`;
            orgSurvey.surveyUrl = `${process.env.VUE_APP_URL}/surveys/${orgSurvey.surveyUrlId}`;
          });
        }

        this.survey = survey;
      },
      gotoRouteLink(data) {
        let routeParams = { name: 'InstanceSummary', params: { surveyId: data.hspSurveyId, urlId: data.surveyUrlId, surveyInfo: this.surveyInfo }};
        if (this.isUser) {
          routeParams.name = "InstanceDashboard";
          routeParams.params.routeFrom = "instances";
        }

        return routeParams;
      },
      initialize() {
        let hasParamData = !isNullOrEmpty(this.$route.params.surveyInfo) && this.$route.params.surveyInfo.indexOf("hspSurveyId") > -1;
        if (hasParamData) {
          this.survey = JSON.parse(this.$route.params.surveyInfo);
          this.surveyInfo = this.$route.params.surveyInfo;
        }
        else {
          this.getAssignedSurveys();
          this.surveyInfo = JSON.stringify(this.survey);
        }
      },
    },
    created() {
      this.initialize();
    },
  };
</script>
<style scoped>
  .cell {
    word-break: normal !important;
  }
  .btn-icon {
    font-size: 1.4em;
  }
</style>
